// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__mFJ5h","extraSpacing":"Content_extraSpacing__3SpIg"};